import Form from 'mobx-react-form';
import * as validatorjs from 'validatorjs';
import plugins from './plugins';


const fields = {
    name: {
        name: 'listName',
        key: 'name',
        label: 'List name',
        rules: 'string|required',
        placeholder: 'e.g. Human Resources',
    },
};

class ListForm extends Form {
    constructor(setup, options) {
        super({ fields, ...setup }, { plugins, ...options });
    }
}

export default ListForm;
